import React, { memo } from 'react';
import { styled } from '@compiled/react';

const PRIORITY_ICON_SIZE = 20;

export type Props = {
	iconUrl?: string | null;
};

const PriorityIcon = ({ iconUrl }: Props) => (iconUrl == null ? null : <ImageIcon src={iconUrl} />);

export default memo<Props>(PriorityIcon);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ImageIcon = styled.img({
	width: `${PRIORITY_ICON_SIZE}px`,
	height: `${PRIORITY_ICON_SIZE}px`,
});
